import { LIST_PERMISSIONS, LOADING_PERMISSIONS } from "../../constants/types";
import { GenericRootThunkAction } from "../../types/common";
import { IPermissions } from "../../types/user/permissions/ipermissions/ipermissions.interface";

export const setPermissions = (newPermissions?: IPermissions): GenericRootThunkAction => async (
  dispatch
) => {
  dispatch({ type: LOADING_PERMISSIONS });

  if (newPermissions) {
    dispatch({
      type: LIST_PERMISSIONS,
      payload: {
        permissions: newPermissions,
      },
    });
  }
};
